var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'wgt-goods-grid': true,
    'padded': _vm.value.padded
  }},[_c('div',{staticClass:"hm-title-box"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.value.title)+" ")]),_c('div',{staticClass:"title-btn"},[_c('div',{staticClass:"title-subtitle"},[_vm._v(_vm._s(_vm.value.cta.desc))]),_vm._m(0)])]),_c('div',{staticClass:"hm-title-pic"},[_c('el-row',_vm._l((_vm.value.data),function(item,index){return _c('el-col',{key:index,attrs:{"span":6}},[_c('sp-image',{attrs:{"src":item.imgUrl,"circle":0}})],1)}),1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"el-icon-arrow-right"})])
}]

export { render, staticRenderFns }